import { useEffect, useState } from 'react'
import * as communityApi from '../lib/api/community'
import * as statsApi from '../lib/api/stats'
import { originClustersToMapPoints, type OriginMapPoint } from '../lib/originCityCoords'

export type CommunitySocialProofLiveState =
  | { status: 'idle' | 'loading' }
  | {
      status: 'ready'
      recentMembers: communityApi.CommunityRecentMember[]
      recentMembersAvailable: boolean
      mapPoints: OriginMapPoint[]
      mappedCityCount: number
    }
  | { status: 'error' }

const RECENT_MEMBERS_LIMIT = 16

export function useCommunitySocialProofLive() {
  const [state, setState] = useState<CommunitySocialProofLiveState>({ status: 'idle' })

  useEffect(() => {
    let cancelled = false
    setState({ status: 'loading' })

    void (async () => {
      try {
        const [recentResult, clustersResult] = await Promise.allSettled([
          communityApi.listCommunityRecentMembers(RECENT_MEMBERS_LIMIT),
          statsApi.listOriginClusters(),
        ])

        if (cancelled) return

        const recentMembers =
          recentResult.status === 'fulfilled' ? recentResult.value : []
        const clusters =
          clustersResult.status === 'fulfilled' ? clustersResult.value : []
        const mapPoints = originClustersToMapPoints(clusters)

        setState({
          status: 'ready',
          recentMembers,
          recentMembersAvailable: recentResult.status === 'fulfilled',
          mapPoints,
          mappedCityCount: mapPoints.length,
        })
      } catch {
        if (!cancelled) setState({ status: 'error' })
      }
    })()

    return () => {
      cancelled = true
    }
  }, [])

  return state
}
